import { forwardRef } from 'react'

const Card = forwardRef(function Card({ as: Component = 'div', className = '', accent = false, children, ...props }, ref) {
    return (
        <Component
            ref={ref}
            className={[
                'rounded-none border-2 bg-white dark:bg-zinc-950',
                accent ? 'border-accent' : 'border-black dark:border-white',
                className,
            ].join(' ')}
            {...props}
        >
            {children}
        </Component>
    )
})

export default Card
